import { createSlice } from '@reduxjs/toolkit';

export type Attachment = {
  id: number;
  content: string;
};

export type Document = {
  id: number;
  name: string;
  belonging: string;
  tags: string[];
  attachments: Attachment[];
};

type InitialState = {
  documents: Document[] | null;
};

const initialState: InitialState = {
  documents: null,
};

const documentsSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    setDocumentsData: (state, action) => {
      state.documents = action.payload;
    },
  },
});

export const { setDocumentsData } = documentsSlice.actions;
export default documentsSlice.reducer;
